export const Status = {
  Completed: 'Complete',
  InProgress: 'Inprogress',
  New: 'New',
} as const;
interface Props {
  customTitle?: string;
  status: string;
}

interface StatusProperties {
  backgroundColor: string;
  title: string;
  titleColor: string;
}

type StatusType = (typeof Status)[keyof typeof Status];

// eslint-disable-next-line react-refresh/only-export-components
export const statusMap: Record<StatusType, StatusProperties> = {
  [Status.Completed]: {
    backgroundColor: 'bg-theme-500',
    title: 'Completed',
    titleColor: 'text-theme-200 min-w-20',
  },
  [Status.InProgress]: {
    backgroundColor: 'bg-primary-cyan',
    title: 'In Progress',
    titleColor: 'text-primary-blue min-w-20',
  },
  [Status.New]: {
    backgroundColor: 'bg-primary-yellow',
    title: 'Start',
    titleColor: 'text-secondary-orange-4 min-w-8',
  },
};

const StatusLabel = ({ customTitle, status }: Props) => {
  const statusProperties = statusMap[status];

  return (
    <div
      className={`flex h-fit shrink-0 items-center justify-center rounded-xl p-1 px-3 text-center ${statusProperties.backgroundColor}`}
    >
      <span className={`${statusProperties.titleColor} text-[0.75rem] font-semibold`}>
        {customTitle || statusProperties.title}
      </span>
    </div>
  );
};

export default StatusLabel;
